// Runtime polyfills, imported first in main.js so they run before any app code. This is the single
// home for "teach an older browser a newer built-in" shims — add future ones here rather than inline
// at the call site.

// Promise.withResolvers: native in Safari 17.4+, Chrome 119+, Firefox 121+, but the browserslist
// target ("last 2 versions", "> 1%") still admits older Safari, and the app build does not inject
// core-js polyfills for used built-ins, so a bare call would throw there.
if (typeof Promise.withResolvers !== 'function') {
	Promise.withResolvers = function withResolvers() {
		let resolve
		let reject
		const promise = new Promise((res, rej) => {
			resolve = res
			reject = rej
		})
		return { promise, resolve, reject }
	}
}
